import React from "react";

import {
  useMiddleware,
  EmitFunction,
} from "@piqnt/runtime-core/react/ReactMount";
import { OutlineContext } from "./OutlineContext";

import { getLabel } from "@piqnt/runtime-core/common/Label";
import { getKey } from "@piqnt/runtime-core/common/Key";
import { Joint } from "planck";

interface LiveJointComponentProps {
  emit: EmitFunction;
  joint: Joint;
  selected: boolean;
  selectable?: boolean;
}

class LiveJointComponent extends React.PureComponent<LiveJointComponentProps> {
  handleClick = () => {
    const { emit, joint } = this.props;
    emit("select-joint", { joint: getKey(joint) });
  };

  render() {
    const { joint, selected, selectable } = this.props;
    if (!joint) {
      return null;
    }
    const label = getLabel(joint);
    let className = "";
    className += selected ? "selected-item " : "";
    className += selectable ? "clickable " : "";
    return (
      <span
        className={className}
        onClick={selectable ? this.handleClick : null}
      >
        {label ? "joint#" + label : (joint.getType() ?? "")}
      </span>
    );
  }
}

interface LiveJointProps {
  joint: Joint;
  selectable?: boolean;
}

export const LiveJoint = (props: LiveJointProps) => {
  const { context, emit } = useMiddleware<OutlineContext>();
  const jointKey = getKey(props.joint);
  const selected = !!context.multiselect?.value.findKey(jointKey);

  return (
    <LiveJointComponent
      joint={props.joint}
      selectable={props.selectable}
      emit={emit}
      selected={selected}
    />
  );
};
